module.exports = __webpack_public_path__ + "img/menu.4256f039.svg";